import React from 'react';
import moment from 'moment';
import {ViewType} from '../../types';
import {useSelector} from "react-redux";

interface DateIndicatorProps {
  date: string;
  left: number;
  viewType: ViewType;
  top: number;
}

export const DateIndicatorFlag: React.FC<DateIndicatorProps> = ({
  date,
  left,
  viewType,
  top,
}) => {
  const {
    suppressDateIndicator
  } = useSelector((state: any) => state.timeline);

  const formatDate = (dateStr: string, viewType: ViewType) => {
    const momentDate = moment(dateStr);
    
    switch (viewType) {
      case 'weekly':
        return momentDate.format('dddd, MMM DD, YYYY');
      case 'monthly':
        return momentDate.format('ddd, MMM DD, YYYY');
      case 'quarterly':
        return momentDate.format('ddd, MMM DD, YYYY');
      case 'yearly':
        return momentDate.format('ddd, MMM DD, YYYY');
      default:
        return momentDate.format('ddd, MMM DD, YYYY');
    }
  };

  if (suppressDateIndicator) return null;
  
  return (
    <div
      className="z-[39] absolute bg-slate-600 dark:bg-slate-300 h-full"
      style={{
        width: 1,
        left: left,
        pointerEvents: 'none'
      }}
    >
      <div
        className="sticky"
        style={{
          top: top,
          pointerEvents: 'none'
        }}
      >
        <span
          className="shadow-sm bg-slate-700 dark:bg-slate-200 text-white dark:text-slate-900 text-xs px-2 py-1 rounded-r whitespace-nowrap border border-slate-500 dark:border-slate-400"
        >
          {formatDate(date, viewType)}
        </span>
      </div>
    </div>
  );
};